import PageMeta from '@/components/base/PageMeta';
import SchemaOrg from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedCategories from './components/FeaturedCategories';
import PopularArticles from './components/PopularArticles';
import RomanticPackages from './components/RomanticPackages';
import Destinations from './components/Destinations';
import Testimonials from './components/Testimonials';
import NewsletterSection from './components/NewsletterSection';
import { siteInfo } from '@/mocks/siteInfo';

export default function Home() {
  return (
    <>
      <PageMeta
        title="爱情岛 - 浪漫邂逅与心动体验的专属乐园 | 情侣旅游攻略"
        description="爱情岛，专为情侣打造的浪漫目的地，汇聚心动约会攻略、蜜月旅行灵感与独特爱情体验。无论是初恋的悸动还是长久陪伴的温柔，爱情岛带你感受最真实的浪漫时光。"
        keywords="爱情岛,爱情岛情侣旅游攻略,爱情岛蜜月旅行,爱情岛约会体验,爱情岛浪漫套餐,爱情岛打卡景点,爱情岛度假推荐"
        canonicalUrl={siteInfo.url}
        ogImage="https://readdy.ai/api/search-image?query=Romantic%20couple%20travel%20destination%20collage%20with%20beach%20sunset%2C%20ancient%20city%2C%20and%20luxury%20resort%2C%20warm%20golden%20tones%2C%20elegant%20travel%20magazine%20cover%20style&width=1200&height=630&seq=og-home&orientation=landscape"
      />

      <SchemaOrg type="Organization" data={{
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        foundingDate: siteInfo.foundingYear.toString(),
        contactPoint: { '@type': 'ContactPoint', telephone: siteInfo.phone, contactType: 'customer service' },
        sameAs: [siteInfo.socialLinks.weibo, siteInfo.socialLinks.xiaohongshu, siteInfo.socialLinks.douyin],
      }} />

      <SchemaOrg type="WebSite" data={{
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        potentialAction: { '@type': 'SearchAction', target: `${siteInfo.url}/search?q={search_term_string}`, 'query-input': 'required name=search_term_string' },
      }} />

      <SchemaOrg type="WebPage" data={{
        name: `${siteInfo.name} - 首页`,
        url: siteInfo.url,
        description: siteInfo.description,
        isPartOf: { '@type': 'WebSite', name: siteInfo.name, url: siteInfo.url },
      }} />

      <div className="min-h-screen">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedCategories />
          <PopularArticles />
          <RomanticPackages />
          <Destinations />
          <Testimonials />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
}